import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {thunkUserLogin} from "../store/thunks";
import {UserState,User} from "../store/user/types";
import {AppState} from "../store";
import {connect} from "react-redux";
import Alert from "../common/component/Alert";

interface IHeaderProps {
    thunkUserLogin: any;
    user: UserState;
    open: boolean;
    t: any;
    closeDialog : any;  
}

interface IHeaderState {
    open: boolean;
    username: string;
    password: string;
    showError: boolean;
}

class LoginDialog extends React.Component<IHeaderProps, IHeaderState> {

    state = {
        open: this.props.open,
        username: '',
        password: '',
        showError: false
    }

    login = (event: any) => {
        this.props.thunkUserLogin({login: this.state.username, password: this.state.password}).then(() =>{
            if (!this.props.user.isLoggedIn){
                this.setState({showError: true});

            } else {
                this.handleClose();
        }
        this.setState({username: '', password:''});
        });        
    };

    handleClose = () =>{
        this.setState({open: false});
        this.props.closeDialog();
    }    

    handleChange = (name: string) => (event: React.ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        this.setState(prevState => ({
                ...prevState,
                [name]: value
        }));
    };

    closeSnackbar = () => {
        this.setState({showError: false});
    }

    handleEnter = (event : React.KeyboardEvent) =>{
        if(event.keyCode == 13){
            this.login(event);
      }
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{this.props.t('LoginDialog.title')}</DialogTitle>
                    <DialogContent>
                        <form onKeyDown={this.handleEnter}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="user">{this.props.t('LoginDialog.username')}</InputLabel>
                                <Input id="user" name="user" autoComplete="user" value={this.state.username}
                                       onChange={this.handleChange('username')} autoFocus/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">{this.props.t('LoginDialog.password')}</InputLabel>
                                <Input name="password" type="password" id="password" value={this.state.password}
                                       onChange={this.handleChange('password')} autoComplete="current-password"/>
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            {this.props.t('LoginDialog.cancel')}
                        </Button>
                        <Button onClick={this.login} color="primary">
                            {this.props.t('LoginDialog.signIn')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Alert open={this.state.showError} message="Anmeldung fehlgeschlagen" onClose={this.closeSnackbar} type='error'/>
            </div>
        );
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (nextProps.open != this.state.open) {
            nextState.open = nextProps.open;
        }
        return true;
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps,{thunkUserLogin})(LoginDialog);